import type { ReactElement } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import Home from "../pages/home/page";
import GamesPage from "../pages/Games";
import BonusPage from "../pages/Bonus";
import AboutPage from "../pages/About";
import TermsPage from "../pages/Terms.tsx";
import ResponsibleGamingPage from "../pages/ResponsibleGaming";
import FAQPage from "../pages/FAQ.tsx";
import KeywordLanding from "../pages/KeywordLanding";
import { KEYWORD_PAGES } from "../constants/keywordPages";

/** Match both `/path` and `/path/` so links and refreshes behave the same. */
function withOptionalTrailingSlash(path: string, element: ReactElement): RouteObject[] {
  const base = path.replace(/\/+$/, "") || "/";
  if (base === "/") {
    return [{ path: "/", element }];
  }
  return [
    { path: base, element },
    { path: `${base}/`, element },
  ];
}

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  ...withOptionalTrailingSlash("/games", <GamesPage />),
  ...withOptionalTrailingSlash("/bonus", <BonusPage />),
  ...withOptionalTrailingSlash("/about", <AboutPage />),
  ...withOptionalTrailingSlash("/terms", <TermsPage />),
  ...withOptionalTrailingSlash("/responsible-gaming", <ResponsibleGamingPage />),
  ...withOptionalTrailingSlash("/faq", <FAQPage />),
  ...KEYWORD_PAGES.flatMap((page) =>
    withOptionalTrailingSlash(`/${page.slug}`, <KeywordLanding slug={page.slug} />)
  ),
  { path: "*", element: <Navigate to="/" replace /> },
];

export default routes;
